import PropTypes from 'prop-types';
import React from 'react';

import {normalizeTagName} from '../utils';

const TagFilter = (props) => {
	function handleTagChange(e) {
		const tagName = e.target.value === 'all' ? null : e.target.value;
		if (tagName !== props.selectedTag) {
			props.setSelectedTag(tagName);
		}
	}

	return (
		<div className="bsknacht17-filter">
			<select
				value={props.selectedTag}
				onChange={handleTagChange}
				onBlur={handleTagChange}
			>
				<option key="all" value="all">
					— Nach Kategorie filtern —
				</option>

				{props.tagHierarchy.map((tag) =>
					tag.children && tag.children.length ? (
						<optgroup key={`group-${tag.name}`} label={tag.name}>
							<option
								key={`group-all-${tag.name}`}
								value={normalizeTagName(tag.name)}
							>
								Alle aus {tag.name}
							</option>
							{tag.children.map((tagChild) => (
								<option
									key={tagChild.name}
									value={normalizeTagName(tagChild.name)}
								>
									{tagChild.name}
								</option>
							))}
						</optgroup>
					) : (
						<option
							key={tag.name}
							value={normalizeTagName(tag.name)}
						>
							{tag.name}
						</option>
					)
				)}
			</select>
		</div>
	);
};

TagFilter.propTypes = {
	setSelectedTag: PropTypes.func.isRequired,
	tagHierarchy: PropTypes.arrayOf(PropTypes.object).isRequired,
	selectedTag: PropTypes.string,
};

export default TagFilter;
